<template>
  <v-select
      :items="options"
      v-model="priority"
      outlined
      hide-details="auto"
      :rules="rules"
      style="max-width: 15em"
  ></v-select>
</template>

<script>
export default {
  name: 'DefectReportStatusSelect',
  props: {
    value: {
      required: true,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  computed: {

    priority: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
        this.$emit('change', value);
      },
    },

    options() {
      const statuses = ['NEW', 'OPEN', 'FIXED', 'INVALID'];

      return statuses.map(status => {
        return {
          text: this.$options.filters.defectReportStatus(status),
          value: status,
        };
      });
    },
  },
};
</script>
